// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__4McXK","filesListContainer":"PosDisputesFiles_filesListContainer__l0jan","filesButton":"PosDisputesFiles_filesButton__37eLF"};